import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../index';
import fImg from '@images/faq/faq-right-bg.webp'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';



const FaqSection = (props) => {
    const { language } = useContext(LanguageContext);
    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    // Define FAQ content for both languages
    const faqContent = {
        pl: {
            sectionTitle: {
                subtitle: "ABC podłóg drewnianych",
                title: <>Drewniana podłoga bez <span className="thin">tajemnic</span></>
            },
            items: [
                {
                    header: "Klasyka gatunku",
                    body: <>DOBRZE wykonane podłogi drewniane nadadzą Twoim wnętrzom naturalności w ponadczasowym
                    stylu. Do produkcji naszych desek podłogowych wybraliśmy drewno DĘBOWE. To jeden z
                    najpiękniejszych surowców naturalnych w Europie. Piękno podłóg dębowych Fabri
                    podziwia się oczami, ale komfort będziesz czuć pod stopami.</>
                },
                {
                    header: "Indywidualny styl",
                    body: <>W jakiej tonacji będziesz się czuć najlepiej w swoim domu?
                    Odwiedź nasz salon, aby wybrać podłogę dla siebie. Masz do wyboru ponad 100 barwień;
                    ciemnych, jasnych, naturalnych, bejcowanych, postarzanych lub przypalanych. Twój
                    wybór będzie dotyczyć również klasy drewna, szerokości desek i ułożenia: prostego,
                    klasycznego, francuskiego a nawet krzywoliniowego. Po określeniu przez Ciebie tych
                    parametrów rozpoczniemy produkcję.</>
                },
                {
                    header: "Impregnacja",
                    body: <>Do ochrony dębu używamy autorskich i naturalnych olejowosków twardych, dlatego nasze
                    podłogi NIE WYMAGAJĄ dodatkowych impregnacji przed sezonem letnim lub zimowym. Nasze
                    olejowoski są hydrofobowe to znaczy nie wchłaniają plam. Do utrzymania czystości
                    wystarcza nawilżony WODĄ mop (lub robot). Na nasze podłogi NIE NALEŻY stosować
                    detergentów, ich opary nie służą naszemu zdrowiu.</>
                },
                {
                    header: "Szczotkowanie",
                    body: <>Obowiązkowym procesem przy produkcji podłóg naturalnych jest szczotkowanie
                    (satynowanie). W tym procesie zostają usunięte wszystkie pyłki i miększe włókna
                    wierzchniej warstwy drewna, dzięki czemu pozostaje najtwardsza warstwa odporna na
                    zarysowania i uszkodzenia mechaniczne. Przy okazji tworzymy niepowtarzalną i
                    naturalną strukturę drewna, wyczuwalną w dotyku.</>
                },
                {
                    header: "Wytrzymałość i ogrzewanie podłogowe",
                    body: <>Znamy wszystkie swoje wcześniejsze realizacje i wiemy, że deski naszej produkcji
                    doskonale współgrają z ogrzewaniem podłogowym, zachowując swoje początkowe parametry.
                    Dzieje się tak, ponieważ podstawą naszych desek jest wielowarstwowa sklejka
                    LIŚCIASTA. Połączenie DĘBU z taką konstrukcją, czyni deski Fabri najmocniejszymi na
                    rynku! Dodatkowo ochrona dębu olejowoskami twardymi, pozwala na wieloletni i
                    bezobsługowy komfort użytkowania.</>
                }
            ]
        },
        en: {
            sectionTitle: {
                subtitle: "ABC of wooden floors",
                title: <>Wooden floor without <span className="thin">secrets</span></>
            },
            items: [
                {
                    header: "A genre classic",
                    body: <>Well-crafted wooden floors will bring a sense of natural beauty and timeless style to your interiors. For the production of our floorboards, we have chosen oak wood – one of the most beautiful natural materials in Europe. The beauty of Fabri’s oak floors is something you admire with your eyes, but the comfort is something you’ll feel underfoot.</>
                },
                {
                    header: "individual style ",
                    body: <>What tone will make you feel most at home?
                    Visit our showroom to choose the perfect floor for your space. You can select from over 100 finishes – dark, light, natural, stained, aged, or charred.
                    You’ll also choose the wood grade, plank width, and pattern – whether straight, classic, French herringbone, or even curved layouts.
                    Once you define these parameters, we’ll begin production tailored to your choices.</>
                },
                {
                    header: "Impregnation",
                    body: <>We protect our oak floors using our own natural hard oil-waxes, so they do not require any additional treatment before the summer or winter seasons.
                    Our oil-waxes are hydrophobic, meaning they repel stains instead of absorbing them.
                    To keep the floors clean, all you need is a water-dampened mop (or a cleaning robot).
                    Do not use detergents on our floors – their fumes are harmful to your health.</>
                },
                {
                    header: "brushing",
                    body: <>Brushing (also known as satin-finishing) is an essential step in the production of natural wood floors.
                    During this process, all dust particles and softer surface fibers are removed, leaving behind the hardest, most durable layer – resistant to scratches and mechanical damage.
                    At the same time, we create a unique, natural texture of the wood that can be felt to the touch.</>
                },
                {
                    header: "durability and underfloor heating",
                    body: <>We know every one of our past projects, and we’re confident that our floorboards work perfectly with underfloor heating systems, maintaining their original properties over time.
                    This is possible because the core of our boards is made from multi-layered hardwood plywood.
                    The combination of oak with this construction makes Fabri boards among the strongest on the market.
                    Additionally, the protection provided by hard oil-waxes ensures long-lasting, maintenance-free comfort for years to come.</>
                }
            ]
        }
    };

    const content = faqContent[language] || faqContent.pl;

    return (
        <section className="faq-section">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 pr-125 rpr-15">
                        <div className="faq-left-image"></div>
                    </div>
                    <div className="col-lg-6 pl-0">
                        <div className="faq-accordion ras-content pt-95 pb-110 rpb-0 rmb-100">
                            <div className="section-title mb-35">
                                <h6>{content.sectionTitle.subtitle}</h6>
                                <h2>{content.sectionTitle.title}</h2>
                            </div>
                            <div id="accordion">
                                <Accordion open={open} toggle={toggle}>
                                    {content.items.map((item, idx) => (
                                        <AccordionItem className='card' key={idx}>
                                            <AccordionHeader targetId={(idx + 1).toString()} className='card-header'>
                                                {item.header}
                                            </AccordionHeader>
                                            <AccordionBody accordionId={(idx + 1).toString()}>
                                                {item.body}
                                            </AccordionBody>
                                        </AccordionItem>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                        <div className="faq-right-bg">
                            <img src={fImg} alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default FaqSection;